import { FlatTreeElement } from '../models/flatTreeElement.model';

// Function that determines whether a flat node is expandable or not
export function getIsNodeExpandable({ node }: FlatTreeElement) {
  return node?.children?.length > 0;
}
